export default "__VITE_ASSET__CyTXNEx6__"